/* eslint-disable  */
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { productActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import { debounce } from "lodash";
import ReactPaginate from "react-paginate";
import {
  FiSearch,
  FiTruck,
  FiCalendar,
  FiPackage,
  FiEye,
  FiArrowRight,
} from "react-icons/fi";

function ShippedOrders() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetShippedOrders, ResetProductResponse } = bindActionCreators(
    productActionCreators,
    dispatch
  );

  const product = useSelector((state) => state.product);
  const { isLoading, orders, response, paginate } = product;

  const [limit, setLimit] = useState(15);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetShippedOrders(true, 1, limit, null);
  }, []);

  useEffect(() => {
    GetShippedOrders(true, 1, limit, null);
  }, [limit]);

  const handlePageClick = (event) => {
    GetShippedOrders(true, event.selected + 1, limit, null);
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    GetShippedOrders(true, 1, limit, val ? `&search=${val}` : null);
  }, 800);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div className="min-h-screen bg-gray-50/30">
      <RenderHirePurchasePage>
        {isLoading && <Loader />}

        {/* --- Header Section --- */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-100 rounded-lg text-blue-600">
              <FiTruck size={24} />
            </div>
            <h2 className="text-2xl font-bold text-gray-800">Shipped Orders</h2>
          </div>
          <p className="text-sm text-gray-500">
            Track and manage items currently in transit to members.
          </p>
        </div>

        {/* --- Toolbar --- */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-6">
          <div className="md:col-span-8 relative">
            <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="search"
              placeholder="Search by staff ID, name or facility..."
              className="w-full pl-12 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 outline-none transition-all"
              onChange={onSearchTextChange}
            />
          </div>

          <div className="md:col-span-4 flex items-center justify-end gap-3 bg-white px-4 py-2 rounded-xl border border-gray-200 shadow-sm">
            <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">
              Show
            </span>
            <select
              className="text-sm font-semibold text-gray-700 outline-none bg-transparent cursor-pointer"
              onChange={(e) => setLimit(e.target.value)}
              value={limit}
            >
              {[15, 25, 50, 100].map((num) => (
                <option key={num} value={num}>
                  {num} items
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* --- Data Table --- */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-50/50 border-b border-gray-100">
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Recipient
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Affordability
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Shipment Date
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Facility
                  </th>
                  <th className="px-6 py-4 text-center text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-4 text-right"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {orders?.length > 0 ? (
                  orders.map((order, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50/20 transition-colors group"
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <img
                            className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-sm"
                            src={
                              order?.user_id?.profile_image ||
                              "https://ui-avatars.com/api/?name=" +
                                order?.user_id?.name
                            }
                            alt=""
                          />
                          <div>
                            <p className="text-sm font-bold text-gray-900 group-hover:text-blue-700 transition-colors">
                              {order?.user_id?.name}
                            </p>
                            <p className="text-xs font-medium text-gray-400">
                              ID: {order?.user_id?.staff_id}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm font-semibold text-gray-700">
                          {order?.affordability}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <FiCalendar className="text-gray-400" />
                          {moment(order?.created_at).format("MMM Do, YYYY")}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <FiPackage className="text-gray-400" />
                          {order?.facility}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold bg-blue-100 text-blue-700">
                          <span className="w-1.5 h-1.5 rounded-full bg-blue-500 mr-2 animate-pulse"></span>
                          IN TRANSIT
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() =>
                            history.push({
                              pathname: "/mart/order-detailed",
                              state: order,
                            })
                          }
                          className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-bold text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg transition-all border border-blue-100"
                        >
                          DETAILS <FiArrowRight />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="px-6 py-24 text-center">
                      <div className="flex flex-col items-center opacity-40">
                        <FiTruck size={48} className="mb-4" />
                        <p className="text-lg font-bold italic">
                          No orders currently in transit
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          {orders?.length > 0 && (
            <div className="px-6 py-6 bg-gray-50/50 flex justify-center border-t border-gray-100">
              <ReactPaginate
                breakLabel="..."
                nextLabel="Next"
                previousLabel="Prev"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(pageCount / limit)}
                containerClassName="flex items-center gap-1"
                pageLinkClassName="w-10 h-10 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-sm font-semibold text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-all shadow-sm"
                activeLinkClassName="!bg-blue-600 !text-white !border-blue-600 shadow-blue-200 shadow-md"
                previousLinkClassName="px-4 h-10 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-sm font-semibold text-gray-600 hover:bg-gray-50 mr-2"
                nextLinkClassName="px-4 h-10 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-sm font-semibold text-gray-600 hover:bg-gray-50 ml-2"
                disabledLinkClassName="opacity-40 cursor-not-allowed"
              />
            </div>
          )}
        </div>
        <ToastContainer autoClose={3000} position="top-right" />
      </RenderHirePurchasePage>
    </div>
  );
}

export default ShippedOrders;
